import React from 'react';

export default class FreeTextEntry extends React.Component {

    onChange(event) {
        this.props.update(this.props.propertyName, event.target.value);
    }

    render() {
        return (
            <div>
                <label className="input-label">{this.props.title}</label>
                <input type="text" value={this.props.value || ''} onChange={this.onChange.bind(this)} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/FreeTextEntry.jsx